import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row w-full" }
const _hoisted_2 = {
  class: "bg-modal w-maxC",
  style: {"padding":"0.3rem","min-width":"8rem"}
}
const _hoisted_3 = {
  key: 1,
  class: "row mleft-auto gap-01"
}
const _hoisted_4 = {
  key: 1,
  class: "row pad-m"
}
const _hoisted_5 = { class: "row gap-02" }
const _hoisted_6 = {
  key: 0,
  class: "col gap-02 mleft-02"
}
const _hoisted_7 = {
  key: 1,
  class: "row gap-02 mright-06"
}
const _hoisted_8 = {
  key: 0,
  class: "row gap-02 mright-06"
}
const _hoisted_9 = { class: "row-bottom" }
const _hoisted_10 = {
  key: 2,
  class: "col mright-06"
}
const _hoisted_11 = { class: "row gap-02 w-full" }
const _hoisted_12 = {
  key: 1,
  class: "pad-s"
}
const _hoisted_13 = { class: "psides-02" }
const _hoisted_14 = {
  key: 0,
  class: "row w-full mtop-04",
  style: {"margin-bottom":"-0.7rem"}
}
const _hoisted_15 = {
  key: 0,
  class: "height-scroll pright-20"
}
const _hoisted_16 = { class: "col gap-30 mleft-06" }
const _hoisted_17 = {
  key: 0,
  class: "w-full"
}
const _hoisted_18 = { class: "row-top" }
const _hoisted_19 = {
  key: 2,
  class: "row gap-04 mleft-10"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "row-top" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "row-top" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = {
  key: 0,
  class: "col gap-30"
}
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "col" }
const _hoisted_30 = {
  key: 0,
  class: "row"
}
const _hoisted_31 = {
  key: 0,
  style: {"width":"1.5rem"}
}
const _hoisted_32 = {
  key: 0,
  class: "pad-0 row-top gap-08"
}
const _hoisted_33 = { class: "row-top gap-08 w-full" }
const _hoisted_34 = {
  key: 1,
  class: "col"
}
const _hoisted_35 = { class: "col" }
const _hoisted_36 = {
  key: 0,
  style: {"width":"1.5rem"}
}
const _hoisted_37 = { class: "row-top gap-08 w-full" }
const _hoisted_38 = {
  key: 0,
  class: "pad-0 row-top gap-08"
}
const _hoisted_39 = {
  key: 0,
  class: "row"
}

import middleColumnGrid from '../middleColumnGrid.vue'
import docBioAddOn from './docBioAddOn.vue'
import docImagingAddOn from './docImagingAddOn.vue'
import docRecipientsAddOn from './docRecipientsAddOn.vue'
import docLuBillAddOn from './docLuBillAddOn.vue'
import docLuBillAddOnFinancialGroups from './docLuBillAddOnFinancialGroups.vue'
import editDocumentFieldPreference from './editDocumentFieldPreference.vue'
import createRefDocument from '@/views/patientMain/combinedReference/createRefDocument.vue'

import { Routes } from "@/models/layout.model";
import { getPatientDocIcon } from '@/functions/expression'
import { useRouter } from 'vue-router'
import { ref, computed, watch, nextTick } from 'vue'
import patientapi from "@/api/patientapi"
import gen from "@/functions/general.js"
import { useCurrentEntryStore } from '@/stores/currentEntry'
import appuserapi from "@/api/appuserapi"
import { useI18n } from 'vue-i18n'
import SharedService from "@/services/SharedService";
import { AccountingApi, FinancialGroupLightResponse, FinancialChannelLightResponse, FolderPatientApi, PatientDocument, PatientDocumentVersion } from '@/apiGenerate/medserver'
import { toastError } from '@/utils/toast-utils'
import { Select, useToast } from 'primevue'
import { splitSuggestions } from '@/functions/documentSuggestions'
import { medServerApiConfig } from '@/config/medserver-api.config'
import officeapi from '@/api/officeapi';
import { SmallPageableDefault } from '@/models/share.model';
import { useFinancialGroupsStore } from '@/stores/financialGroups'
import { PatientDocumentOption, PatientDocumentVersionOption } from '@/models/patientDocument.model'
import { getPatientDocumentVersion } from '@/utils/patientDocument-utils'
import { useComputeRelativeDate } from '@/compsables/useComputeRelativeDate'


export default /*@__PURE__*/_defineComponent({
  __name: 'middleDocument',
  setup(__props) {

const financialGroupsStore = useFinancialGroupsStore()
const accountingApi = new AccountingApi(medServerApiConfig)
const folderPatientApi = new FolderPatientApi(medServerApiConfig);
const toast = useToast();

const currentEntryStore = useCurrentEntryStore()
const { t } = useI18n();
const router = useRouter();
const computeRelativeDate = useComputeRelativeDate();

const dropd = ref("")
const inputRefs = ref<(HTMLInputElement | HTMLTextAreaElement)[]>([]);
const loading = ref<boolean>(false);
const hasMore = ref<boolean>(true);
const page = ref<number>(0);
const docs = ref<Array<PatientDocument>>([]);

const currFinancialGroup = ref<FinancialGroupLightResponse>(null);

const isEditable = computed(() => {
  return currentEntryStore.isEditable && !currentEntryStore.currentEntry.archivedByUser;
});

const isCurrentDocumentOnCurrentEntry = computed<boolean>(() => {
  const doc = currentEntryStore.currentDoc.patientDocument;
  return doc.entry?.relationshipId === currentEntryStore.currentEntryId;
});

const isCurrentDocumentLatestVersion = computed<boolean>(() => {
  const doc = currentEntryStore.currentDoc.patientDocument;
  if (!doc.versions || doc.versions.length < 1) {
    return true;
  }

  const latestVersion = doc.versions[doc.versions.length - 1];
  return latestVersion.patientDocumentId === doc.patientDocumentId;
});

const internalCode = computed(() => {
  if (!templateDocument.value) return "";
  return templateDocument.value.patientDocument.documentGroup.internalCode;
})

const isBill = computed(() => {
  return internalCode.value === 'Bill'
})

const canDuplicateBill = computed(() => {
  if (internalCode.value !== 'Bill') return false;
  const currentDoc = currentEntryStore.currentDoc;
  const financialGroupId = currentDoc?.patientDocument.invoice?.financialGroupId;
  if (!financialGroupId) return false;
  return financialGroupsStore.hasFinancialGroup(financialGroupId);
})

const currPatientDocText = computed(() => {
  const currEntryDate = currentEntryStore.currentEntryDate
  const documentEntryDate = currentEntryStore.currentDoc.patientDocument.entry.entryStart
  return computeRelativeDate(documentEntryDate, currEntryDate)
})

const alreadyHasBill = computed(() => {
  if (!isBill.value) return false;
  const currentDocId = templateDocument.value.patientDocument.patientDocumentId;
  return docs.value?.some(
    doc => doc.entry.relationshipId === currentEntryStore.currentEntryId
        && doc.patientDocumentId !== currentDocId
  );
});

const documentOptions = computed<PatientDocumentOption[]>(() => docs.value.map(doc => {
  let versionLabel: string | undefined;
  if (doc.versions && doc.versions.length > 1) {
    const docVersion = doc.versions.find(({ patientDocumentId }) => doc.patientDocumentId === patientDocumentId);
    versionLabel = docVersion?.version ? t('common.version', { version: docVersion.version }) : undefined;
  }
  return {
    value: doc.patientDocumentId,
    label: doc.originalText,
    status: doc.templateStatus,
    documentGroupInternalCode: doc.documentGroup.internalCode,
    version: versionLabel
  };
}));

const currentDocVersions = computed<PatientDocumentVersionOption[]>(() => {
  if (!currentEntryStore.currentDoc || !currentEntryStore.currentDoc.patientDocument.versions) {
    return [];
  }

  return currentEntryStore.currentDoc.patientDocument.versions.map((docVersion: PatientDocumentVersion) => ({
    value: docVersion.patientDocumentId,
    label: t('common.version', { version: docVersion.version })
  }));
});

async function onPatientDocumentSelect(option: PatientDocumentOption) {
  //Reload
  dropd.value = ""
  currentEntryStore.emptyCurrentDoc();
  const fullPatientDoc = await patientapi.getPatientDocument(`${option.value}`, currentEntryStore.currentEntryId);
  
  const patientDocument = fullPatientDoc.patientDocument;
  const version = getPatientDocumentVersion(patientDocument);

  currentEntryStore.setSelectedDocumentOption(option, version ? {
    value: version.patientDocumentId,
    label: t('common.version', { version: version.version })
  } : undefined);
  currentEntryStore.setCurrentDoc(fullPatientDoc)
}

const onPatientDocumentVersionSelect = async (option: PatientDocumentVersionOption) => {
  currentEntryStore.emptyCurrentDoc();
  const fullPatientDoc = await patientapi.getPatientDocument(`${option.value}`, currentEntryStore.currentEntryId);

  currentEntryStore.setSelectedDocumentVersionOption(option);
  currentEntryStore.setCurrentDoc(fullPatientDoc);
}

//Load template data
const templateDocument = ref(null);


const templateGroupType = computed(() => {
  if (!templateDocument.value) return "";
  return templateDocument.value.patientDocument.documentGroup.documentGroupType
})

const isTemplateStatus = computed(() => {
  if (!templateDocument.value) return false;
  return templateDocument.value?.patientDocument.templateStatus === 'Template'
})

function isDynamicList(item) {
  if (item.uiSelector.uiType === 'CclListUi') return true;
  if (item.uiSelector.uiType !== 'ListUi') return false;
  if (!item.dataTable.length) return true;      //Empty lists are always dynamic
  const hasCodeCNS = item.dataTable[0].codeCNS  //if codeCns -> manual physio list
  if (hasCodeCNS) return false;
  const id = item.dataTable[0].id;
  const isNumeric = /^\d+$/.test(id);           //Manual List IDs are never Long
  const isUuid = id.length === 36;              //Manual List IDs are never UUID
  return isNumeric || isUuid;
}

const templateStatus = computed(() => {
  if (!templateDocument.value) return "";
  return templateDocument.value.patientDocument.templateStatus
})

function isEmptySelectorData(item) {
  const uiType = item.uiSelector.uiType
  if (uiType === 'BooleanUi') {
    return false
  } else if (['CclListUi', 'ListUi'].includes(uiType)) {
    if (item.dataTable.length == 0) {return true;}
    return item.dataTable.every(row => row.selected !== 'true')
  } else {
    return (item.dataTable[0] == '')
  }
}

function showFormattedDate(isoDateString) {
  const locale = 'de-DE';
  const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
  const showDate = new Date(isoDateString);
  return showDate.toLocaleDateString(locale, options);
}

//COPY INTO FIELD
function selectInput(fieldId) {
  const inputElement = inputRefs.value[fieldId];
  if (!inputElement) return;
  const textareaElement = inputElement.innerRef
  currentEntryStore.setActiveField(fieldId, textareaElement);
}

const handleInputBlur = () => {
  if (currentEntryStore.activeFieldElement == null) return;
  nextTick(() => {
    currentEntryStore.clearActiveField();
  })
}

//UPDATE TEMPLATE DATA
function newTextInputFct(uiSelectorData) {
  const selectorDataId = uiSelectorData.uiSelectorDataId
  const newText = uiSelectorData.dataTable[0]
  updateMinMax(uiSelectorData)
  debouncedUpdate(selectorDataId, newText)
}

function changeDate(uiSelectorData, newText) {
  const selectorDataId = uiSelectorData.uiSelectorDataId
  uiSelectorData.dataTable[0] = newText
  updateMinMax(uiSelectorData)
  debouncedUpdate(selectorDataId, newText);
}

async function updateDocumentFieldPreference(uiSelector, newText) {
  //Quick frontend update
  if (!uiSelector.documentFieldPreference) {
    uiSelector.documentFieldPreference = {}
    uiSelector.documentFieldPreference.autoUseFirst = false;
  }
  uiSelector.documentFieldPreference.suggestions = newText
  //Update backend
  await appuserapi.updateDocumentFieldSuggestions(uiSelector.uiSelectorName, newText)  
}

async function handleUpdateAutoUseFirstSugg(uiSelector, newAutoUse) {
  if (!uiSelector.documentFieldPreference) {
    uiSelector.documentFieldPreference = {}
    uiSelector.documentFieldPreference.suggestions = "";
  }
  uiSelector.documentFieldPreference.autoUseFirst = newAutoUse;
  await appuserapi.updateAutoUseFirstDocFieldSuggestion(uiSelector.uiSelectorName, newAutoUse)
}

function getSplitSuggestions(uiSelector) {
  const suggestions = uiSelector.documentFieldPreference?.suggestions || uiSelector.textSuggestions;
  return splitSuggestions(suggestions);
}

function createNewContent(oldContent: string, suggestion: string) {
  const base = oldContent.replace(/ $/, '');
  const separator = base.endsWith('\n') ? '' : ' ';
  return base + separator + suggestion;
}

function suggestionAddFct(uiListIndex, suggItem: string, uiItem) {
  let uiSelectorData = templateDocument.value.uiSelectorData[uiListIndex]
  const oldDataTable = uiSelectorData.dataTable[0]
  const newDataTable = (oldDataTable === "") ? suggItem : createNewContent(oldDataTable, suggItem);
  
  //FrontEnd
  uiSelectorData.dataTable[0] = newDataTable
  updateMinMax(uiSelectorData)
  //Focus
  focusElement(uiItem.uiSelectorDataId)
  //Backend
  updateData(uiSelectorData.uiSelectorDataId, newDataTable)
}

function suggestionReplaceFct(uiListIndex, suggItem, uiItem) {
  let uiSelectorData = templateDocument.value.uiSelectorData[uiListIndex]
  //FrontEnd
  uiSelectorData.dataTable[0] = suggItem
  updateMinMax(uiSelectorData)
  //Focus
  focusElement(uiItem.uiSelectorDataId)  
  //Backend
  updateData(uiSelectorData.uiSelectorDataId, suggItem)
}


function prescribeFullCclList(uiListIndex, cclId) {
  const uiSelectorData = templateDocument.value.uiSelectorData[uiListIndex]
  const bioExpressionsForCcl = uiSelectorData.dataTable.filter((item) => {
    return item.cclId === cclId
  })
  const allSelected = bioExpressionsForCcl.every(item => item.selected === 'true')
  if (allSelected) {
    //Update Frontend
    uiSelectorData.dataTable.forEach(row => {
      if (row.cclId  === cclId) {
        row.selected = 'false'
      }
    })
    updateMinMax(uiSelectorData)
    //Update Backend
    updateData(uiSelectorData.uiSelectorDataId, JSON.stringify(uiSelectorData.dataTable))
  } else {
    //Update Frontend
    uiSelectorData.dataTable.forEach(row => {
      if (row.cclId === cclId) {
        row.selected = 'true'
      }
    })
    updateMinMax(uiSelectorData)
    //Update Backend
    updateData(uiSelectorData.uiSelectorDataId, JSON.stringify(uiSelectorData.dataTable))
  }
}


function prescribeFullSoloList(uiListIndex) {
  console.log("prescribeFullSoloList")
  const uiSelectorData = templateDocument.value.uiSelectorData[uiListIndex]
  const allSelected = uiSelectorData.dataTable.every(item => item.selected === 'true')
  if (allSelected) {
    //Update Frontend
    uiSelectorData.dataTable.forEach(row => {
      row.selected = 'false'
    })
    updateMinMax(uiSelectorData)
    //Update Backend
    updateData(uiSelectorData.uiSelectorDataId, JSON.stringify(uiSelectorData.dataTable))
  } else {
    //Update Frontend
    uiSelectorData.dataTable.forEach(row => {
      row.selected = 'true'
    })
    updateMinMax(uiSelectorData)
    //Update Backend
    updateData(uiSelectorData.uiSelectorDataId, JSON.stringify(uiSelectorData.dataTable))
  }
}

function listInputFct(uiListIndex, rowIndex) {
  let uiSelectorData = templateDocument.value.uiSelectorData[uiListIndex]
  const maxSelect = uiSelectorData.uiSelector.maxSelect
  const minSelect = uiSelectorData.uiSelector.minSelect
  let oldText = uiSelectorData.dataTable[rowIndex].selected
  let newText = (oldText !== 'true') ? 'true' : 'false'
  //Update FrontEnd
  if (newText === 'true') {
    if (maxSelect === 0) {
      //Directly adopt
      uiSelectorData.dataTable[rowIndex].selected = newText
    } else if (maxSelect === 1) {
      //First set all rows to 'false' first
      uiSelectorData.dataTable.forEach(row => {row.selected = 'false'})
      uiSelectorData.dataTable[rowIndex].selected = newText
    } else {
      uiSelectorData.dataTable[rowIndex].selected = newText
    }
  } else {
    if (maxSelect === 0) {
      //Directly adopt
      uiSelectorData.dataTable[rowIndex].selected = newText
    } else {
      //If minSelect > 1, count first
      let countTrue = 0
      uiSelectorData.dataTable.forEach(row => {
        if (row.selected === 'true') {countTrue ++}
      })
      if (countTrue > minSelect) {
        uiSelectorData.dataTable[rowIndex].selected = newText
      }
    }
  }
  updateMinMax(uiSelectorData)
  //Update Backend
  updateData(uiSelectorData.uiSelectorDataId, JSON.stringify(uiSelectorData.dataTable))
}

function updateMinMax(uiSelectorData) {
  if (['CclListUi', 'ListUi'].includes(uiSelectorData.uiSelector.uiType)) {
    let selections = 0
    uiSelectorData.dataTable.forEach(row => {
        if (row.selected == 'true') {selections++}
    })
    const minSelect = uiSelectorData.uiSelector.minSelect
    const maxSelect = uiSelectorData.uiSelector.maxSelect
    if (minSelect > 0 && maxSelect > 0) {
      uiSelectorData.invalidMinMax = selections < minSelect || selections > maxSelect
    } else if (minSelect > 0) {
      uiSelectorData.invalidMinMax = selections < minSelect
    } else if (maxSelect > 0) {
      uiSelectorData.invalidMinMax = selections > maxSelect
    }
  } else {
    const uiSelectorDataTable = uiSelectorData.dataTable[0]
    uiSelectorData.invalidMinMax = uiSelectorData.uiSelector.minSelect > 0 && uiSelectorDataTable.trim() === ''
  }
  countInvalid()
}

function countInvalid() {
  let invalid = 0
  templateDocument.value.uiSelectorData.forEach(uiSelectorData => {
    if (uiSelectorData.invalidMinMax == true) {invalid++}
  })
  templateDocument.value.invalid = invalid
}

function booleanFct(uiListIndex) {
  let uiSelectorData = templateDocument.value.uiSelectorData[uiListIndex]
  let oldText = uiSelectorData.dataTable[0]
  let newText = (oldText !== 'true') ? 'true' : 'false'
  //Update FrontEnd
  uiSelectorData.dataTable[0] = newText
  //Update Backend
  updateData(uiSelectorData.uiSelectorDataId, newText)
}

const debouncedByField = new Map();

function debouncedUpdate(uiSelectorDataId: string, newString: string) {
  let fn = debouncedByField.get(uiSelectorDataId);
  if (!fn) {
    fn = gen.createDebouncedFn((id: string, str: string) => updateData(id, str), 500);
    debouncedByField.set(uiSelectorDataId, fn);
  }
  fn(uiSelectorDataId, newString);
}

const pendingChains = new Map()
const pendingUpdates = new Set()

async function updateData(uiSelectorDataId, newString: string) {
  const previous = pendingChains.get(uiSelectorDataId) || Promise.resolve()
  const chain = previous.then(() =>
    patientapi.updateUiSelectorData(uiSelectorDataId, newString, currentEntryStore.currentEntryId)
  )
  pendingChains.set(uiSelectorDataId, chain.catch(() => { /* swallow to keep chain alive */ }))
  pendingUpdates.add(chain)
  chain.finally(() => pendingUpdates.delete(chain))
  return chain
}

async function flushPendingUpdates() {
  for (const fn of debouncedByField.values()) {
    fn.flush();
  }
  if (pendingUpdates.size) {
    await Promise.allSettled([...pendingUpdates])
  }
}

function trackUpdate(promise) {
  if (!promise) return
  pendingUpdates.add(promise)
  promise.finally(() => pendingUpdates.delete(promise))
}

//FINALIZATION, PRINT, ESEND
const localPdfBlob = ref(null)
const localPdfUrl = ref(null)

async function showPdf() {
  await getPdf()
  if (!localPdfUrl.value) {return}
  window.open(localPdfUrl.value)
}

async function downloadPdf() {
  await getPdf()
  if (!localPdfBlob.value) {return}
  const fileName = currentEntryStore.currentDoc?.patientDocument?.originalText
  const fileExtension = "pdf" //uiStore.dashBoardItem.resultDocumentFile.fileExtension

  gen.downloadBlob(localPdfBlob.value, fileName, fileExtension)
}

async function duplicate(newVersion?: boolean) {
  if (templateDocument.value.patientDocument.templateStatus === 'Template') {
    return;
  }
  const patientDocId = currentEntryStore.currentDocId
  const conclusionGroupId = currentEntryStore.currentCcl?.conclusionGroupId.toString() || currentEntryStore.currentNullCclId.toString()
  //Reload
  currentEntryStore.emptyCurrentDoc();
  const newDoc = await patientapi.duplicatePatientDocument(patientDocId, conclusionGroupId, currentEntryStore.currentEntryId, newVersion);
  currentEntryStore.setCurrentDoc(newDoc);
  currentEntryStore.reloadCurrentEntry();
}

async function prescribeBio() {
  const originalText = "Bio"
  currentEntryStore.setMiddleTab('docTemplate')
  currentEntryStore.emptyCurrentDoc()
  const newDoc = await patientapi.addOfficialTemplateToCclZero("BioRequest", originalText, "", "None", currentEntryStore.currentEntryId, null)
  currentEntryStore.setCurrentDoc(newDoc)
  currentEntryStore.reloadCurrentEntry()
}


async function deletePatientDocument() {
  const patientDocId = currentEntryStore.currentDocId

  //Frontend
  currentEntryStore.emptyCurrentDoc()
  if (currentEntryStore.currentCcl) {
    currentEntryStore.setMiddleTab('cclSuggestions')
  } else {
    currentEntryStore.setMiddleTab('resultSuggestions')
  }

  //Backend
  await patientapi.deletePatientDocument(patientDocId)
  currentEntryStore.reloadCurrentEntry()
}

async function finalize() {
  if (templateDocument.value.patientDocument.templateStatus !== 'Template') {console.log("Function only valid for templates"); return;}
  if (isBill.value) {console.log("Function only valid for non bills"); return;}
  await flushPendingUpdates();
  //Frontend
  templateDocument.value.patientDocument.templateStatus = 'Complete'
  localPdfBlob.value = null
  localPdfUrl.value = null
  //Backend & reload
  const patientDocId = currentEntryStore.currentDocId
  const patientDoc = await patientapi.finalizePatientDocument(patientDocId, currentEntryStore.currentEntryId)
  currentEntryStore.setCurrentDoc(patientDoc)
  currentEntryStore.reloadCurrentEntry()
}



//RELOAD FUNCTIONS
async function showDocument() {
  if (!currentEntryStore.currentDoc) {templateDocument.value = null; return;}
  let currDoc = gen.deepCopy(currentEntryStore.currentDoc)
  const currTemplateStatus = currDoc.patientDocument.templateStatus
  if (currTemplateStatus === 'None') {
    templateDocument.value = currDoc
    return
  }

  //Sort
  currDoc.uiSelectorData = Object.values(currDoc.uiSelectorData).sort((a, b) => a.uiOrder - b.uiOrder)

  //Nested
  currDoc.uiSelectorData.forEach(uiSelectorData => {
    if (uiSelectorData.uiSelector.uiType !== "CclListUi" || currTemplateStatus !== 'Template') {return;}
    uiSelectorData.nestedDataTable = []
    uiSelectorData.dataTable.forEach((uiData, index) => {
      uiData.index = index
      const { entryId, entryTerm, cclId } = uiData
      //Each entry should only be present once
      let entryData = uiSelectorData.nestedDataTable.find(item => item.entryId === entryId)
      if (!entryData) {
        entryData = {
          entryId,
          entryTerm,
          data: { [cclId]: [uiData] }
        }
        uiSelectorData.nestedDataTable.push(entryData)
      } else {
        //Each ccl should only be present once
        let cclData = entryData.data[cclId] ||= []
        cclData.push(uiData)
      }
    })
    //Sort
    uiSelectorData.nestedDataTable.sort((a, b) => {
      return new Date(b.entryTerm.split(".")[2] + "/" + b.entryTerm.split(".")[1] + "/" + b.entryTerm.split(".")[0]) - 
              new Date(a.entryTerm.split(".")[2] + "/" + a.entryTerm.split(".")[1] + "/" + a.entryTerm.split(".")[0]);
    })
  })

  templateDocument.value = currDoc
  countInvalid()
}

async function getPdf() {
  if (!currentEntryStore.currentDoc) {return;}
  if (templateDocument.value.patientDocument.templateStatus === 'Template') {return;}
  if (localPdfBlob.value != null) {return;}   //don't reload if it's the same document

  const respBlob = await patientapi.getPatientDocumentPdfStream(currentEntryStore.currentDocId)
  localPdfBlob.value = respBlob

  const myBlob= new Blob([respBlob], {type: 'application/pdf'})
  localPdfUrl.value = window.URL.createObjectURL(myBlob)
}

async function reloadDocument() {
  templateDocument.value = null;
  localPdfBlob.value = null;
  localPdfUrl.value = null;
  showDocument();
}

watch(
  () => currFinancialGroup.value?.id,
  (newId) => {
    if (newId) loadFinancialGroup()
  },
  { immediate: true }
)

const allDirectPaymentChannels = ref<FinancialChannelLightResponse[]>([]);
const allUnpaidChannels = ref<FinancialChannelLightResponse[]>([]);
async function loadFinancialGroup() {
  const financialGroupId = currFinancialGroup.value?.id;
  if (!financialGroupId) {
    allDirectPaymentChannels.value = [];
    allUnpaidChannels.value = [];
    return;
  }
  try {
    const response: FinancialChannelLightResponse[] = await accountingApi.getChannelsByFinancialGroup({ financialGroupId: financialGroupId })
    allDirectPaymentChannels.value = response.filter(channel => 
      ["Cash", "BankCard", "DigitalPayment"].includes(channel.type)
    );
    allUnpaidChannels.value = response.filter(channel => 
      ["LuTp", "LuTpSocial"].includes(channel.type)
    );

  } catch (error) {
    console.error('Error fetching invoice:', error)
  }
}

async function finalizeToChannelAndOpenAccounting(financialChannel: FinancialChannelLightResponse) {
  if (templateDocument.value.patientDocument.templateStatus !== 'Template') {console.log("Function only valid for templates"); return;}
  if (!isBill.value) {console.log("Function only valid for bills"); return;}
  //Precomplete
  await precompleteBill();
  const invoice = templateDocument.value.patientDocument.invoice;
  //Open Accounting dashboard
  router.push({
    path: `/${Routes.FINANCE}`,
    query: { 
      financialGroupId: currFinancialGroup.value?.id,
      targetChannelId: financialChannel.id,
      invoiceRef: invoice.invoiceReference
    }
  });
}

async function finalizeToChannelAndReload(financialChannel: FinancialChannelLightResponse) {
  if (templateDocument.value.patientDocument.templateStatus !== 'Template') {console.log("Function only valid for templates"); return;}
  if (!isBill.value) {console.log("Function only valid for bills"); return;}
  //Precomplete
  await precompleteBill();
  const invoice = templateDocument.value.patientDocument.invoice;
  const patientDocumentId = templateDocument.value.patientDocument.patientDocumentId;
  const targetChannelId = financialChannel.id.toString();
  const remainingBalance = invoice.remainingBalance;
  const invoiceDateTime = invoice.invoiceDateTime;
  //AddTransaction
  await officeapi.addTransaction(null, targetChannelId, invoice.id, invoiceDateTime, remainingBalance);
  //Relolad
  const patientDoc = await patientapi.getPatientDocument(patientDocumentId, currentEntryStore.currentEntryId)
  currentEntryStore.setCurrentDoc(patientDoc);
  currentEntryStore.reloadCurrentEntry();
}

async function finalizeToUnpaid() {
  if (templateDocument.value.patientDocument.templateStatus !== 'Template') {console.log("Function only valid for templates"); return;}
  if (!isBill.value) {console.log("Function only valid for bills"); return;}
  //Precomplete
  await precompleteBill();
  const invoice = templateDocument.value.patientDocument.invoice;
  const patientDocumentId = templateDocument.value.patientDocument.patientDocumentId;
  //Finalize
  await officeapi.finalizeInvoiceToUnpaid(invoice.id);
  //Relolad
  const patientDoc = await patientapi.getPatientDocument(patientDocumentId, currentEntryStore.currentEntryId)
  currentEntryStore.setCurrentDoc(patientDoc);
  currentEntryStore.reloadCurrentEntry();
}

async function finalizeToUnpaidAndPrint() {
  await finalizeToUnpaid();
  printPdf();
}

/* eSend it's a mock, we unactivate for the moment
//eSend
async function eSend() {
  const patientDocId = currentEntryStore.currentDocId
  templateDocument.value.patientDocument.templateStatus = 'Scheduled'
  await patientapi.eTransmitPatientDocument(patientDocId)
}*/

// async function finalizeAndESend() {
//   await finalize()
//   //eSend() eSend it's a mock, we unactivate for the moment
// }

//Print
async function finalizeAndPrintPdf() {
  await finalize()
  printPdf()
}

async function printPdf() {
  await getPdf()
  if (!localPdfBlob.value) {return}
  gen.printBlob(localPdfBlob.value, "Pdf")
}

function focusElement(uiId) {
  if (!uiId) {return;}
  nextTick(() => {
    const inputElement = inputRefs.value[uiId];
    if (!inputElement) {return;}

    inputElement.innerRef.focus();
  })
}

async function reloadRecipients() {
  currentEntryStore.reloadPatientOnly();
  const patientDocumentId = templateDocument.value.patientDocument.patientDocumentId;
  const updatedPatientDocument = await patientapi.getPatientDocument(patientDocumentId, currentEntryStore.currentEntryId);
  currentEntryStore.setCurrentDoc(updatedPatientDocument);
  reloadDocument();
}

function suggestionClearFct(uiListIndex, uiItem) {
  let uiSelectorData = templateDocument.value.uiSelectorData[uiListIndex];
  const newDataTable = "";
  //FrontEnd
  uiSelectorData.dataTable[0] = "";
  updateMinMax(uiSelectorData);
  //Focus
  focusElement(uiItem.uiSelectorDataId);
  //Backend
  updateData(uiSelectorData.uiSelectorDataId, newDataTable);
}

async function precompleteBill() {
  if (templateDocument.value.patientDocument.templateStatus !== 'Template') {console.log("Function only valid for templates"); return;}
  if (!isBill.value) {console.log("Function only valid for bills"); return;}
  await flushPendingUpdates();
  //Frontend
  templateDocument.value.patientDocument.templateStatus = 'Precomplete'
  localPdfBlob.value = null
  localPdfUrl.value = null
  //Backend & reload
  const patientDocId = currentEntryStore.currentDocId
  await patientapi.precompletePatientDocumentWithBill(patientDocId, currFinancialGroup.value.id.toString(), currentEntryStore.currentEntryId).then((patientDoc) => {
    currentEntryStore.setCurrentDoc(patientDoc);
    currentEntryStore.reloadCurrentEntry();
  }).catch((error) => {
    console.log(error)
      if (error.detail) {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: t(`error.${error.detail}`)
        });
      } else {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: t('error.INVOICE_GENERATE_ERROR')
        });
      }
  });
}


const loadMore = async () => {
  if (loading.value || !hasMore.value) return;

  loading.value = true;

  try {
    const nextPage = page.value + 1;

    const result = await loadPage(nextPage);

    docs.value = [...docs.value, ...result.docs];
    page.value = nextPage;
    hasMore.value = !result.last;
  } finally {
    loading.value = false;
  }
};

const loadPage = async (pageToLoad: number) => {
  const response = await folderPatientApi.getPatientDocuments({
    patientId: currentEntryStore.currentPatient.personWithRoleId,
    documentGroupId: currentEntryStore.currentDoc.patientDocument.documentGroup.documentGroupId,
    currentConsultationsId: currentEntryStore.currentEntryId,
    page: pageToLoad,
    size: SmallPageableDefault.limit
  });

  const mappedDocs = response.documents.map(patientDoc => ({
    ...patientDoc,
    originalText:
      computeRelativeDate(
        patientDoc.entry.entryStart,
        currentEntryStore.currentEntryDate
      ) + " - " + patientDoc.originalText
  }));

  return {
    docs: mappedDocs,
    last: response.last
  };
};

const handleScroll = (e: any) => {
  const el = e.target;
  const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 20;
  if (nearBottom) loadMore();
};

watch(
  () => currentEntryStore.currentDoc,
  async (currentDoc) => {
    reloadDocument();
    if (!currentDoc) return;

    page.value = 0;
    hasMore.value = true;
    docs.value = [];

    const result = await loadPage(0);

    docs.value = result.docs;
    hasMore.value = !result.last;
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_inputNewDate = _resolveComponent("inputNewDate")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_listGroup = _resolveComponent("listGroup")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_switchGroup = _resolveComponent("switchGroup")!

  return (_openBlock(), _createBlock(middleColumnGrid, null, {
    row1: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_text_item, {
          txt: _unref(currentEntryStore).currentDoc?.patientDocument?.originalText || _unref(t)('common.loading'),
          class: "pad-m",
          styles: "font-l"
        }, null, 8, ["txt"]),
        (templateDocument.value && !['Bill', 'BioRequest', 'MedicRequest'].includes(internalCode.value))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_dropdownBox, {
                modelValue: dropd.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dropd).value = $event)),
                openOn: "AddReferenceDocument"
              }, {
                dropd: _withCtx(() => [
                  _createVNode(createRefDocument, {
                    onAfterReferenceDocumentCreation: _cache[0] || (_cache[0] = ($event: any) => (dropd.value = ''))
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_dropdownBox, {
                modelValue: dropd.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dropd).value = $event)),
                openOn: "CurrentDocumentMenu"
              }, {
                dropd: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_dbGroup, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_list_group, {
                          class: "w-full",
                          styles: "pad-m",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (dropd.value = 'AddReferenceDocument'))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_svg_item, {
                              icon: "bookOpen",
                              styles: "main-m"
                            }),
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('refSheet.referenceDocument.create'),
                              styles: "main-m",
                              class: "mleft-04"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_buttonGroup, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_item, {
                        icon: "moreVertical",
                        styles: "size-l main-m"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], 64))
          : _createCommentVNode("", true),
        (templateDocument.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (currentDocVersions.value.length > 1)
                ? (_openBlock(), _createBlock(_unref(Select), {
                    key: 0,
                    options: currentDocVersions.value,
                    modelValue: _unref(currentEntryStore).selectedDocVersionOption,
                    optionLabel: "label",
                    checkmark: "",
                    "onUpdate:modelValue": onPatientDocumentVersionSelect,
                    size: "small",
                    class: "patient-document-select",
                    overlayClass: "patient-document-select__overlay"
                  }, {
                    value: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.value.label), 1)
                    ]),
                    option: _withCtx((slotProps) => [
                      _createVNode(_component_text_item, {
                        txt: slotProps.option.label
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }, 8, ["options", "modelValue"]))
                : _createCommentVNode("", true),
              (templateGroupType.value === 'Bio' || docs.value.length <= 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_svg_item, {
                      icon: _unref(getPatientDocIcon)(templateDocument.value.patientDocument),
                      styles: "main-m"
                    }, null, 8, ["icon"]),
                    _createVNode(_component_text_item, {
                      txt: currPatientDocText.value,
                      styles: "main-m font-s",
                      class: "mleft-02"
                    }, null, 8, ["txt"])
                  ]))
                : (_openBlock(), _createBlock(_unref(Select), {
                    key: 2,
                    options: documentOptions.value,
                    modelValue: _unref(currentEntryStore).selectedDocOption,
                    checkmark: "",
                    size: "small",
                    "onUpdate:modelValue": onPatientDocumentSelect,
                    class: "patient-document-select",
                    overlayClass: "patient-document-select__overlay"
                  }, {
                    value: _withCtx((slotProps) => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_svg_item, {
                          icon: _unref(getPatientDocIcon)(slotProps.value.status, slotProps.value.documentGroupInternalCode),
                          styles: "main-m",
                          class: "square-14"
                        }, null, 8, ["icon"]),
                        _createVNode(_component_text_item, { txt: currPatientDocText.value }, null, 8, ["txt"])
                      ])
                    ]),
                    option: _withCtx((slotProps) => [
                      _createVNode(_component_svg_item, {
                        icon: _unref(getPatientDocIcon)(slotProps.option.status, slotProps.option.documentGroupInternalCode),
                        styles: "main-m",
                        class: "square-14"
                      }, null, 8, ["icon"]),
                      (slotProps.option.version)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_text_item, {
                              txt: slotProps.option.label + ' ' + slotProps.option.version
                            }, null, 8, ["txt"])
                          ]))
                        : (_openBlock(), _createBlock(_component_text_item, {
                            key: 1,
                            txt: slotProps.option.label,
                            class: "mleft-02"
                          }, null, 8, ["txt"]))
                    ]),
                    _: 1
                  }, 8, ["options", "modelValue"]))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    row2: _withCtx(() => [
      (!templateDocument.value)
        ? (_openBlock(), _createBlock(_component_text_item, {
            key: 0,
            txt: _unref(t)('common.loading'),
            styles: "font-m main-m"
          }, null, 8, ["txt"]))
        : _createCommentVNode("", true),
      (templateDocument.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "mleft-auto" }, null, -1)),
            (['Complete', 'Scheduled', 'Exported'].includes(templateStatus.value))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_buttonGroup, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (showPdf()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_item, {
                        icon: "fullScreen",
                        styles: "main-m"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_buttonGroup, {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (downloadPdf()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_item, {
                        icon: "download",
                        styles: "main-m"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_buttonGroup, {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (printPdf()))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_svg_item, {
                          icon: "printer",
                          styles: "main-l size-m"
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (isEditable.value && isCurrentDocumentLatestVersion.value && ['Precomplete', 'Complete', 'Scheduled', 'Exported'].includes(templateStatus.value))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (canDuplicateBill.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 0,
                        class: "padButton-m",
                        styles: "border-h",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (duplicate()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('action.duplicate'),
                            styles: "font-mBold"
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : (templateGroupType.value === 'Bio' && !isCurrentDocumentOnCurrentEntry.value)
                      ? (_openBlock(), _createBlock(_component_buttonGroup, {
                          key: 1,
                          class: "padButton-m",
                          styles: "border-h",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (prescribeBio()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.document.newBio'),
                              styles: "font-mBold"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }))
                      : (!['Bill', 'ReminderLetter'].includes(internalCode.value) && !isCurrentDocumentOnCurrentEntry.value)
                        ? (_openBlock(), _createBlock(_component_button_group, {
                            key: 2,
                            class: "padButton-m",
                            styles: "border-h",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (duplicate()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_text_item, {
                                txt: _unref(t)('action.renew'),
                                styles: "font-mBold"
                              }, null, 8, ["txt"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                  (isCurrentDocumentOnCurrentEntry.value && internalCode.value !== 'Bill')
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 3,
                        class: "padButton-m",
                        styles: "border-h",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (duplicate(true)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('action.correct'),
                            styles: "font-mBold"
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (isTemplateStatus.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (isEditable.value)
                ? (_openBlock(), _createBlock(_component_buttonGroup, {
                    key: 0,
                    style: {"margin-right":"auto","margin-top":"-0.2rem"},
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (deletePatientDocument()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_item, {
                        icon: "trash",
                        styles: "main-l size-m"
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (templateDocument.value.invalid > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_text_item, {
                      txt: templateDocument.value.invalid.toString() + ' champ(s)',
                      styles: "main-alert"
                    }, null, 8, ["txt"])
                  ]))
                : _createCommentVNode("", true),
              (isBill.value && isEditable.value && templateDocument.value.invalid == 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (allUnpaidChannels.value?.length || allDirectPaymentChannels.value?.length)
                      ? (_openBlock(), _createBlock(_component_dropdownBox, {
                          key: 0,
                          modelValue: dropd.value,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((dropd).value = $event)),
                          openOn: "FinancialChannels"
                        }, {
                          dropd: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "bg-modal w-maxC",
                              style: {"padding":"0.3rem"},
                              onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createVNode(_component_dbGroup, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_list_group, {
                                    class: "w-full",
                                    styles: "pad-s",
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (finalizeToUnpaid()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_text_item, {
                                        txt: _unref(t)('patient.document.unpaid'),
                                        class: "psides-04"
                                      }, null, 8, ["txt"]),
                                      _createVNode(_component_buttonGroup, {
                                        class: "mleft-04",
                                        onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (finalizeToUnpaidAndPrint()), ["stop"]))
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_13, [
                                            _createVNode(_component_svg_item, {
                                              icon: "printer",
                                              styles: "main-l",
                                              style: {"margin-top":"-0.1rem"}
                                            })
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "mtop-04 mbottom-04 line-h" }, null, -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allDirectPaymentChannels.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_list_group, {
                                      key: item.id,
                                      class: "w-full",
                                      styles: "pad-s",
                                      onClick: ($event: any) => (finalizeToChannelAndOpenAccounting(item))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_text_item, {
                                          txt: item.title,
                                          class: "psides-04"
                                        }, null, 8, ["txt"])
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  }), 128)),
                                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "mtop-04 mbottom-04 line-h" }, null, -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allUnpaidChannels.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_list_group, {
                                      key: item.id,
                                      class: "w-full",
                                      styles: "pad-s",
                                      onClick: ($event: any) => (finalizeToChannelAndReload(item))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_text_item, {
                                          txt: item.title,
                                          class: "psides-04"
                                        }, null, 8, ["txt"])
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_button_group, {
                              theme: "dropdown",
                              class: "pad-s",
                              style: {"margin-top":"-0.1rem"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_text_item, {
                                  txt: _unref(t)('patient.document.finalizeTo'),
                                  styles: "font-mBold main-m",
                                  class: "mleft-02"
                                }, null, 8, ["txt"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (currFinancialGroup.value)
                      ? (_openBlock(), _createBlock(_component_button_group, {
                          key: 1,
                          class: "mleft-06",
                          styles: "border-h pad-s",
                          style: {"padding-left":"1rem","padding-right":"1rem"},
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (precompleteBill()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('action.validate'),
                              styles: "font-mBold"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
                : (isEditable.value && templateDocument.value.invalid == 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createVNode(_component_button_group, {
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (finalizeAndPrintPdf()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_item, {
                            icon: "printer",
                            styles: "main-l size-m"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_button_group, {
                        class: "mleft-06 header-button",
                        styles: "border-h pad-s",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (finalize()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('action.ok'),
                            styles: "font-mBold"
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
            ]),
            (isBill.value && isTemplateStatus.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(docLuBillAddOnFinancialGroups, {
                    currFinancialGroup: currFinancialGroup.value,
                    "onUpdate:currFinancialGroup": _cache[19] || (_cache[19] = ($event: any) => ((currFinancialGroup).value = $event)),
                    patientDocument: templateDocument.value.patientDocument
                  }, null, 8, ["currFinancialGroup", "patientDocument"]),
                  (alreadyHasBill.value)
                    ? (_openBlock(), _createBlock(_component_text_item, {
                        key: 0,
                        txt: _unref(t)('patient.document.warningInvoiceExists'),
                        styles: "font-m main-alert",
                        class: "mleft-auto pad-m"
                      }, null, 8, ["txt"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    row5: _withCtx(() => [
      (templateDocument.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (isTemplateStatus.value && templateGroupType.value === 'Bio')
                ? (_openBlock(), _createBlock(docBioAddOn, { key: 0 }))
                : _createCommentVNode("", true),
              (isTemplateStatus.value && templateGroupType.value === 'Imaging')
                ? (_openBlock(), _createBlock(docImagingAddOn, { key: 1 }))
                : _createCommentVNode("", true),
              (isBill.value)
                ? (_openBlock(), _createBlock(docLuBillAddOn, {
                    key: 2,
                    currFinancialGroup: currFinancialGroup.value,
                    "onUpdate:currFinancialGroup": _cache[20] || (_cache[20] = ($event: any) => ((currFinancialGroup).value = $event)),
                    patientDocument: templateDocument.value.patientDocument,
                    onChanged: trackUpdate
                  }, null, 8, ["currFinancialGroup", "patientDocument"]))
                : _createCommentVNode("", true),
              (templateDocument.value.uiSelectorData)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(templateDocument.value.uiSelectorData, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (isTemplateStatus.value || !isEmptySelectorData(item))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              (!(item.uiSelector.uiType === 'CclListUi') || !isTemplateStatus.value)
                                ? (_openBlock(), _createBlock(_component_text_item, {
                                    key: 0,
                                    txt: item.uiSelector.uiSelectorLabel,
                                    styles: "font-mBold",
                                    class: "linebreak"
                                  }, null, 8, ["txt"]))
                                : _createCommentVNode("", true),
                              (item.uiSelector.uiSelectorName === 'patientRelative')
                                ? (_openBlock(), _createBlock(docRecipientsAddOn, {
                                    key: 1,
                                    onReload: _cache[21] || (_cache[21] = ($event: any) => (reloadRecipients()))
                                  }))
                                : _createCommentVNode("", true),
                              (item.invalidMinMax == true)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    (['CclListUi', 'ListUi'].includes(item.uiSelector.uiType))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createVNode(_component_text_item, {
                                            styles: "main-alert",
                                            txt: "requis:"
                                          }),
                                          (item.uiSelector.minSelect !== 0 && item.uiSelector.maxSelect === 0)
                                            ? (_openBlock(), _createBlock(_component_text_item, {
                                                key: 0,
                                                styles: "main-alert",
                                                txt: "minimum"
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_text_item, {
                                            styles: "main-alert",
                                            txt: item.uiSelector.minSelect.toString()
                                          }, null, 8, ["txt"]),
                                          (item.uiSelector.minSelect !== item.uiSelector.maxSelect && item.uiSelector.maxSelect !== 0)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createVNode(_component_text_item, {
                                                  styles: "main-alert",
                                                  txt: "-"
                                                }),
                                                _createVNode(_component_text_item, {
                                                  styles: "main-alert",
                                                  txt: item.uiSelector.maxSelect.toString()
                                                }, null, 8, ["txt"])
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : (_openBlock(), _createBlock(_component_text_item, {
                                          key: 1,
                                          styles: "main-alert",
                                          txt: "requis"
                                        }))
                                  ]))
                                : _createCommentVNode("", true),
                              (isTemplateStatus.value && !isDynamicList(item))
                                ? (_openBlock(), _createBlock(_component_dropdownBox, {
                                    key: 3,
                                    modelValue: dropd.value,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((dropd).value = $event)),
                                    openOn: 'DocumentFieldPreference' + index
                                  }, {
                                    dropd: _withCtx(() => [
                                      _createVNode(editDocumentFieldPreference, {
                                        uiSelectorData: item,
                                        onUpdate: updateDocumentFieldPreference,
                                        onUpdateAutoUseFirst: handleUpdateAutoUseFirstSugg
                                      }, null, 8, ["uiSelectorData"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_buttonGroup, { class: "icon-button" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_svg_item, {
                                            icon: "settings",
                                            styles: "size-s main-l",
                                            style: {"margin-top":"-0.1rem"}
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "openOn"]))
                                : _createCommentVNode("", true)
                            ]),
                            (item.uiSelector.uiSelectorNote)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_text_item, {
                                    txt: item.uiSelector.uiSelectorNote,
                                    styles: "font-m main-m",
                                    class: "mtop-02 linebreak"
                                  }, null, 8, ["txt"]),
                                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "mtop-04" }, null, -1))
                                ], 64))
                              : _createCommentVNode("", true),
                            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "mtop-04" }, null, -1)),
                            (item.uiSelector.uiType === 'DateUi')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (isTemplateStatus.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        _createVNode(_component_inputNewDate, {
                                          dateIso: item.dataTable[0],
                                          calendar: false,
                                          trash: true,
                                          onDelete: ($event: any) => (changeDate(item, '')),
                                          onChanged: (newIso) => changeDate(item, newIso)
                                        }, null, 8, ["dateIso", "onDelete", "onChanged"])
                                      ]))
                                    : (_openBlock(), _createBlock(_component_dbGroup, { key: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_text_item, {
                                            txt: showFormattedDate(item.dataTable[0]),
                                            styles: "font-m"
                                          }, null, 8, ["txt"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                ], 64))
                              : _createCommentVNode("", true),
                            (item.uiSelector.uiType === 'TextLineUi')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  (isTemplateStatus.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", _hoisted_21, [
                                          _createVNode(_component_inputBox, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_inputLineNew2, {
                                                ref_for: true,
                                                ref: (el) => { inputRefs.value[item.uiSelectorDataId] = el },
                                                modelValue: item.dataTable[0],
                                                "onUpdate:modelValue": ($event: any) => ((item.dataTable[0]) = $event),
                                                onInput: ($event: any) => (newTextInputFct(item))
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_buttonGroup, {
                                            class: "icon-clear",
                                            onClick: ($event: any) => (suggestionClearFct(index, item))
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(SharedService).getIcon('xmark', false, 'shareIcons'),
                                                class: "mtop-01 img-grey"
                                              }, null, 8, _hoisted_22)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _createVNode(_component_dbGroup, { class: "mtop-04" }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSplitSuggestions(item.uiSelector), (suggItem, suggIndex) => {
                                              return (_openBlock(), _createBlock(_component_listGroup, {
                                                key: suggIndex,
                                                class: "pad-0",
                                                onClick: ($event: any) => (suggestionAddFct(index, suggItem.text, item))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_text_item, {
                                                    txt: suggItem.title ?? suggItem.text,
                                                    class: "main-m suggestion-max-w"
                                                  }, null, 8, ["txt"])
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ], 64))
                                    : (_openBlock(), _createBlock(_component_dbGroup, { key: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_text_item, {
                                            txt: item.dataTable[0],
                                            class: "linebreak"
                                          }, null, 8, ["txt"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                ], 64))
                              : _createCommentVNode("", true),
                            (item.uiSelector.uiType === 'TextAreaUi')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  (isTemplateStatus.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", _hoisted_23, [
                                          _createVNode(_component_inputBox, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_inputAreaAuto2, {
                                                ref_for: true,
                                                ref: (el) => { inputRefs.value[item.uiSelectorDataId] = el },
                                                modelValue: item.dataTable[0],
                                                "onUpdate:modelValue": ($event: any) => ((item.dataTable[0]) = $event),
                                                onInput: ($event: any) => (newTextInputFct(item)),
                                                onFocus: ($event: any) => (selectInput(item.uiSelectorDataId)),
                                                onBlur: handleInputBlur
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput", "onFocus"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_buttonGroup, {
                                            class: "icon-clear",
                                            onClick: ($event: any) => (suggestionClearFct(index, item))
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(SharedService).getIcon('xmark', false, 'shareIcons'),
                                                class: "mtop-01 img-grey"
                                              }, null, 8, _hoisted_24)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _createVNode(_component_dbGroup, { class: "mtop-04" }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSplitSuggestions(item.uiSelector), (suggItem, suggIndex) => {
                                              return (_openBlock(), _createBlock(_component_listGroup, {
                                                key: suggIndex,
                                                class: "pad-0",
                                                onClick: ($event: any) => (suggestionAddFct(index, suggItem.text, item))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_text_item, {
                                                    txt: suggItem.title ?? suggItem.text,
                                                    class: "main-m suggestion-max-w"
                                                  }, null, 8, ["txt"])
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ], 64))
                                    : (_openBlock(), _createBlock(_component_dbGroup, { key: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_text_item, {
                                            txt: item.dataTable[0],
                                            class: "linebreak",
                                            styles: "font-m"
                                          }, null, 8, ["txt"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                ], 64))
                              : _createCommentVNode("", true),
                            (item.uiSelector.uiType === 'NumberUi')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  (isTemplateStatus.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", _hoisted_25, [
                                          _createVNode(_component_inputBox, { style: {"width":"3.5rem"} }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_inputLineNew2, {
                                                ref_for: true,
                                                ref: (el) => { inputRefs.value[item.uiSelectorDataId] = el },
                                                modelValue: item.dataTable[0],
                                                "onUpdate:modelValue": ($event: any) => ((item.dataTable[0]) = $event),
                                                onKeydown: _unref(gen).onlyNumber,
                                                onPaste: _unref(gen).onlyNumber,
                                                onInput: ($event: any) => (newTextInputFct(item))
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown", "onPaste", "onInput"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (item.uiSelector.numberUnit)
                                            ? (_openBlock(), _createBlock(_component_text_item, {
                                                key: 0,
                                                txt: item.uiSelector.numberUnit,
                                                class: "mleft-08 main-h linebreak"
                                              }, null, 8, ["txt"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createVNode(_component_dbGroup, { class: "mtop-04" }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSplitSuggestions(item.uiSelector), (suggItem, suggIndex) => {
                                              return (_openBlock(), _createBlock(_component_listGroup, {
                                                key: suggIndex,
                                                class: "pad-0",
                                                onClick: ($event: any) => (suggestionReplaceFct(index, suggItem.text, item))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_text_item, {
                                                    txt: suggItem.title ?? suggItem.text,
                                                    class: "main-m suggestion-max-w"
                                                  }, null, 8, ["txt"])
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ], 64))
                                    : (_openBlock(), _createBlock(_component_dbGroup, { key: 1 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_26, [
                                            _createVNode(_component_text_item, {
                                              txt: item.dataTable[0],
                                              styles: "font-m"
                                            }, null, 8, ["txt"]),
                                            (item.dataTable[0] && item.uiSelector.numberUnit)
                                              ? (_openBlock(), _createBlock(_component_text_item, {
                                                  key: 0,
                                                  txt: item.uiSelector.numberUnit,
                                                  class: "main-h mleft-04 linebreak"
                                                }, null, 8, ["txt"]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024))
                                ], 64))
                              : _createCommentVNode("", true),
                            (item.uiSelector.uiType === 'CclListUi')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                  (isTemplateStatus.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.nestedDataTable, (entryValue, entryIndex) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: entryIndex,
                                            class: "w-full"
                                          }, [
                                            _createVNode(_component_text_item, {
                                              txt: entryValue.entryTerm,
                                              styles: "font-mBold",
                                              class: "linebreak"
                                            }, null, 8, ["txt"]),
                                            _createVNode(_component_dbGroup, { class: "w-full mtop-04" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_28, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entryValue.data, (cclValue, cclKey) => {
                                                    return (_openBlock(), _createBlock(_component_listGroup, {
                                                      key: cclKey,
                                                      class: "pad-0 w-full",
                                                      onClick: ($event: any) => (prescribeFullCclList(index, cclKey))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_29, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cclValue, (exprValue, exprKey) => {
                                                            return (_openBlock(), _createElementBlock(_Fragment, { key: exprKey }, [
                                                              (exprValue.term)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                                    (exprKey !== 0)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_31))
                                                                      : _createCommentVNode("", true),
                                                                    _createVNode(_component_switchGroup, {
                                                                      styles: "padButton-s",
                                                                      active: item.dataTable[exprValue.index].selected === 'true',
                                                                      onClick: _withModifiers(($event: any) => (listInputFct(index, exprValue.index)), ["stop"])
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_text_item, {
                                                                          txt: exprValue.term,
                                                                          class: _normalizeClass(["main-m linebreak", item.dataTable[exprValue.index].selected === 'true' ? 'txt-white' : ''])
                                                                        }, null, 8, ["txt", "class"])
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["active", "onClick"])
                                                                  ]))
                                                                : _createCommentVNode("", true)
                                                            ], 64))
                                                          }), 128))
                                                        ])
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"]))
                                                  }), 128))
                                                ])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]))
                                        }), 128))
                                      ]))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.dataTable, (listRow, rowIndex) => {
                                        return (_openBlock(), _createBlock(_component_dbGroup, { key: rowIndex }, {
                                          default: _withCtx(() => [
                                            (listRow.selected === 'true')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                  _createVNode(_component_text_item, {
                                                    txt: "- ",
                                                    class: "main-h"
                                                  }),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listRow, (value, key, index) => {
                                                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                      (key === 'term')
                                                        ? (_openBlock(), _createBlock(_component_text_item, {
                                                            key: 0,
                                                            txt: value,
                                                            class: "main-h linebreak"
                                                          }, null, 8, ["txt"]))
                                                        : _createCommentVNode("", true)
                                                    ], 64))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                ], 64))
                              : _createCommentVNode("", true),
                            (item.uiSelector.uiType === 'ListUi')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                  (isTemplateStatus.value)
                                    ? (_openBlock(), _createBlock(_component_dbGroup, { key: 0 }, {
                                        default: _withCtx(() => [
                                          (item.uiSelector.maxSelect)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.dataTable, (listRow, rowIndex) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: rowIndex,
                                                  class: "row"
                                                }, [
                                                  _createVNode(_component_switchGroup, {
                                                    styles: "padButton-s",
                                                    active: listRow.selected === 'true',
                                                    onClick: _withModifiers(($event: any) => (listInputFct(index, rowIndex)), ["stop"])
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_33, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listRow, (value, key, index) => {
                                                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                            (key !== 'id' && key !== 'selected' && !key.startsWith('_'))
                                                              ? (_openBlock(), _createBlock(_component_text_item, {
                                                                  key: 0,
                                                                  txt: value,
                                                                  class: _normalizeClass(["main-m linebreak", listRow.selected === 'true' ? 'txt-white': ''])
                                                                }, null, 8, ["txt", "class"]))
                                                              : _createCommentVNode("", true)
                                                          ], 64))
                                                        }), 128))
                                                      ])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["active", "onClick"])
                                                ]))
                                              }), 128))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                _createVNode(_component_listGroup, {
                                                  class: "pad-0 w-full",
                                                  onClick: ($event: any) => (prescribeFullSoloList(index))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_35, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.dataTable, (listRow, rowIndex) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                          key: rowIndex,
                                                          class: "row"
                                                        }, [
                                                          (rowIndex !== 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_36))
                                                            : _createCommentVNode("", true),
                                                          _createVNode(_component_switchGroup, {
                                                            styles: "padButton-s",
                                                            active: listRow.selected === 'true',
                                                            onClick: _withModifiers(($event: any) => (listInputFct(index, rowIndex)), ["stop"])
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("div", _hoisted_37, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listRow, (value, key, index) => {
                                                                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                                    (key !== 'id' && key !== 'selected' && !key.startsWith('_'))
                                                                      ? (_openBlock(), _createBlock(_component_text_item, {
                                                                          key: 0,
                                                                          txt: value,
                                                                          class: _normalizeClass(["main-m linebreak", listRow.selected === 'true' ? 'txt-white': ''])
                                                                        }, null, 8, ["txt", "class"]))
                                                                      : _createCommentVNode("", true)
                                                                  ], 64))
                                                                }), 128))
                                                              ])
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["active", "onClick"])
                                                        ]))
                                                      }), 128))
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ]))
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.dataTable, (listRow, rowIndex) => {
                                        return (_openBlock(), _createBlock(_component_dbGroup, { key: rowIndex }, {
                                          default: _withCtx(() => [
                                            (listRow.selected === 'true')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                  _createVNode(_component_text_item, {
                                                    txt: "- ",
                                                    class: "main-h"
                                                  }),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listRow, (value, key, index) => {
                                                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                      (key !== 'id' && key !== 'selected' && !key.startsWith('_'))
                                                        ? (_openBlock(), _createBlock(_component_text_item, {
                                                            key: 0,
                                                            txt: value,
                                                            class: "main-h linebreak"
                                                          }, null, 8, ["txt"]))
                                                        : _createCommentVNode("", true)
                                                    ], 64))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                ], 64))
                              : _createCommentVNode("", true),
                            (item.uiSelector.uiType === 'BooleanUi')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                  (isTemplateStatus.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                        _createVNode(_component_switchGroup, {
                                          active: item.dataTable[0] === 'true',
                                          onClick: ($event: any) => (booleanFct(index))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_svg_item, {
                                              icon: "check",
                                              styles: "size-m main-m",
                                              class: _normalizeClass(item.dataTable[0] === 'true' ? 'txt-white' : '')
                                            }, null, 8, ["class"])
                                          ]),
                                          _: 2
                                        }, 1032, ["active", "onClick"])
                                      ]))
                                    : (_openBlock(), _createBlock(_component_svg_item, {
                                        key: 1,
                                        icon: item.dataTable[0] === 'true' ? 'check' : 'x',
                                        styles: "size-m main-m"
                                      }, null, 8, ["icon"]))
                                ], 64))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "mtop-20" }, null, -1))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})